import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis d-flex align-center ml-4 mb-2"
}

import { ref, watch, inject, onMounted } from 'vue';
import type { AdminResourcesReadRequest, ResourceDto, ResourceId } from '@/venit/services/model/techpubs-cms';
import { ResourceStatus } from '@/venit/services/model/techpubs-cms';
import ResourceManagementService from '@/venit/admin/resource-management/resource-management.service';
import ResourcePicker from '@/venit/components/resource-picker/resource-picker-dialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'thumbnail-picker-field',
  props: {
    modelValue: {},
    label: {},
    errorMessages: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const resourcesManagementService = inject<() => ResourceManagementService>('resourceService')!;
const resourcePicker = ref<InstanceType<typeof ResourcePicker> | null>(null);

const thumbnailResource = ref<{ name: string; uuid: string; status: ResourceStatus } | null>(null);

const loadThumbnailResource = (uuid: string | null | undefined) => {
  if (!uuid) {
    thumbnailResource.value = null;
    return;
  }
  const request: AdminResourcesReadRequest = { resourceId: { uuid } };
  resourcesManagementService()
    .readResource(request)
    .then(response => {
      thumbnailResource.value = { name: response.data.resourceValue.name, uuid, status: response.data.resourceValue.status };
    });
};

const choose = async () => {
  const resourceId: ResourceId = { uuid: props.modelValue ?? null };
  const resource: ResourceDto | null = await resourcePicker.value?.openDefault(resourceId);
  if (resource) {
    thumbnailResource.value = { name: resource.name, uuid: resource.uuid, status: resource.status };
    emit('update:modelValue', resource.uuid);
  }
};

const clear = () => {
  thumbnailResource.value = null;
  emit('update:modelValue', null);
};

watch(() => props.modelValue, (uuid) => {
  if (uuid !== thumbnailResource.value?.uuid) {
    loadThumbnailResource(uuid);
  }
});

onMounted(() => {
  loadThumbnailResource(props.modelValue);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      "model-value": thumbnailResource.value ? thumbnailResource.value.name : __props.modelValue,
      readonly: "",
      clearable: "",
      label: __props.label,
      "error-messages": __props.errorMessages,
      "hide-details": "auto",
      "onClick:clear": clear
    }, {
      append: _withCtx(() => [
        _createVNode(_component_v_tooltip, {
          text: "Lookup resource for thumbnail",
          location: "top"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createVNode(_component_v_btn, _mergeProps({
              icon: "",
              variant: "text"
            }, tooltipProps, { onClick: choose }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-database-search", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "label", "error-messages"]),
    (thumbnailResource.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, "Resource id: " + _toDisplayString(thumbnailResource.value.uuid), 1 /* TEXT */),
          (thumbnailResource.value.status !== _unref(ResourceStatus).PUBLISHED)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                text: "This resource is not published",
                location: "top"
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                    color: "deep-orange",
                    size: "small",
                    class: "ml-1"
                  }), {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-alert", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(ResourcePicker, {
      ref_key: "resourcePicker",
      ref: resourcePicker
    }, null, 512 /* NEED_PATCH */)
  ]))
}
}

})